var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$router.history.current.name === 'pipelines' || (_vm.status !== 'pause' && _vm.status !== 'stop' && _vm.status !== 'run'))?_c('span',{staticClass:"indicator",class:_vm.classes},[_vm._v("\n  "+_vm._s(_vm.status)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }